import { useContext } from "react";
import { Store } from "../store";
import { getEffectiveUserRole } from "../utils/roles";

/**
 * Hook pour récupérer le rôle de l'utilisateur connecté.
 * Utilise la structure API : role à la racine ou dans user (un seul rôle à la fois).
 */
export function useUserRole(): string {
  const {
    state: { user },
  } = useContext(Store);
  return getEffectiveUserRole(user);
}
